import * as React from "react";
import { ReactNode } from "react";

import { Toaster } from "sonner";
import { BuildInfo } from "~/components/BuildInfo";
import { ConfirmProvider, MessageProvider } from "~/components/Dialogs";
import { ModalProvider } from "~/components/Modal";
import { HeaderView } from "~/views/HeaderView";
import { SidebarView } from "~/views/SidebarView";
import style from "./index.module.scss";
import logoLight from "~/assets/logo/bm-logo.svg";
import logoDark from "~/assets/logo/bm-logo-w.svg";

interface ILayoutProps {
  children: ReactNode;
  links?: ReactNode[];
  className?: string;
  variant?: "default" | "form";
}

export const FullLayout = ({ children, className }: ILayoutProps) => (
  <div className={[style.layout, style.layoutFull, STAGING ? style.layoutStage : style.fullLayoutProd].join(" ")}>
    <ConfirmProvider>
      <MessageProvider>
        <ModalProvider>
          <div className={style.layoutFullHeader}>
            <HeaderView />
          </div>
          <div className={style.layoutFullSidebar}>
            <SidebarView />
          </div>
          <div className={style.layoutFullContent}>
            <div className={[style.layoutFullContentInner, className].join(" ")}>{children}</div>
          </div>
        </ModalProvider>
      </MessageProvider>
    </ConfirmProvider>
    <Toaster richColors position="top-right" offset={18} />
  </div>
);

export const MiddleLayout = ({ children, className, variant = "default" }: ILayoutProps) => {
  const rootClasses = [
    style.layout,
    style.layoutMiddle,
    variant === "form" && style.layoutMiddleForm,
    STAGING ? style.layoutStage : style.middleLayoutProd,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClasses}>
      <div className={[style.layoutMiddleContent, className].join(" ")}>{children}</div>
    </div>
  );
};

export const InfoWrapper = ({ children, className, links }: ILayoutProps) => (
  <div className={style.infoWrapper}>
    <div className={style.infoWrapperHeader}>
      <img
        className={[style.infoWrapperHeaderLogo, style.infoWrapperHeaderLogoLight].join(" ")}
        src={logoLight}
        alt="BidMachine"
      />
      <img
        className={[style.infoWrapperHeaderLogo, style.infoWrapperHeaderLogoDark].join(" ")}
        src={logoDark}
        alt="BidMachine"
      />
      <div className={style.infoWrapperHeaderDesc}>
        Grow your revenue and reach high-quality<br/>users at scale
      </div>
    </div>
    <div className={[style.infoWrapperBody, className].join(" ")}>{children}</div>
    {links && <div className={style.infoWrapperLinks}>{links}</div>}
    <div className={style.infoWrapperFooter}>
      <div className={style.infoWrapperFooterColumn}>
        <p>DSPs</p>
        <p>Interested in Becoming a Demand Partner?</p>
        <p>
          <a href="https://docs.google.com/forms/d/1HueWVyw2QR9IINhNViIYtj81b7IsjyKIc8pDuEK4ZNs/edit" target="_blank">
            Please Fill Out This Request Form
          </a>
        </p>
      </div>
      <div className={style.infoWrapperFooterColumn}>
        <p>Mobile App Publishers</p>
        <p>Interested in Expanding Your Ad Demands?</p>
        <p>Email Us at <a href="mailto:pubdev@bidmachine.io">pubdev@bidmachine.io</a></p>
      </div>
    </div>
    <div className={style.infoWrapperVersion}>
      <BuildInfo />
    </div>
  </div>
);
